import { all, put, takeLatest } from "redux-saga/effects";
import { ActionTypes } from "../constants";
import API from "../requests";
import { ResponseHandler } from "./responseHandler";

export function* timeTravelListGet(action) {
  try {
    const { payload } = action;
    const response = yield API.timeTravelListGet(payload);
    yield put({
      type: ActionTypes.TIME_TRAVEL_LIST_GET_SUCCESS,
      payload: ResponseHandler(response),
    });
  } catch (error) {
    yield put({
      type: ActionTypes.HANDLE_ERRORS_REQUEST,
      successAction: action,
      error: error,
      failedAction: ActionTypes.TIME_TRAVEL_LIST_GET_FAILURE,
    });
  }
}

export default function* root() {
  yield all([
    takeLatest(ActionTypes.TIME_TRAVEL_LIST_GET_REQUEST, timeTravelListGet),
  ]);
}
